<template>
  <v-col :cols="12" :sm="12" :md="12">
    <Alertas :notificacaoSocket="alertaSocket" :texto="alerta.texto" :tipo="alerta.tipo"></Alertas>

    <DataTable
      v-show="showSkeletonTable == false"
      :tableTitle="'Denúncias'"
      :newRowmodalButtonText="'Nova Denúncia'"
      :tableHeader="headers"
      :tableRows="listaDeDenuncias"
      :isEdit="true"
      :isDel="true"
      :isFinish="false"
      :isPrint="false"
      :totalItens="total"
      v-on:datatable-newrow="inserirDenuncia"
      v-on:datatable-updaterow="editarDenuncia"
      v-on:datatable-deleterow="deletarDenuncia"
      v-on:datatable-update-page="updatePage"
      v-on:datatable-update-search="updateSearch"
    ></DataTable>

    <SkeletonTable
      v-show="showSkeletonTable == true"
      :showSkeletonTable="showSkeletonTable"
    ></SkeletonTable>

    <ModalCustomSize
      :modalSize="modalCustomSize.size"
      :isTheModalOpen="modalCustomSize.isOpen"
      :modalButtonText="modalCustomSize.buttonText"
      :modalFormTitle="modalCustomSize.formTitle"
      :modalType="modalCustomSize.modalType"
      :isLoadingRequestDisable="modalCustomSize.isLoadingRequestDisable"
      :isModalButtonVisible="modalCustomSize.isButtonsVisible"
      :isModalButtonDisabled="modalCustomSize.isButtonsDisabled"
      v-on:formmodal-close="modalCustomSize.isOpen = false"
      v-on:formmodal-action="acaoModal"
    >
      <v-form v-model="estaValido">
        <v-row>
          <v-col cols="12">
            <AlertasModal :tipo="alertaModal.tipo" :texto="alertaModal.texto"></AlertasModal>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-checkbox
              label="Nova Empresa" 
              v-model="modalCustomSize.denuncia.novaEmpresa"
              :value="true"
            ></v-checkbox>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="6">
            <v-autocomplete
              v-model="modalCustomSize.denuncia.numeroUsuario"
              :items="listaUsuarios"
              clearable
              label="Selecione um Usuario"
              :rules="[rules.requerido]"
              autocomplete="off"
            ></v-autocomplete>
          </v-col>

          <v-col cols="6">
            <v-menu
              ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="dateFormatted"
                  label="Data Prazo"
                  persistent-hint
                  prepend-icon="mdi-calendar"
                  v-bind="attrs"
                  @blur="date = parseDate(dateFormatted)"
                  v-on="on"
                  :rules="[rules.requerido]"
                  autocomplete="off"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="date"
                no-title
                @input="menu = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
        </v-row>

        <!-- EMPRESA EXISTENTE -->
        <v-expand-transition>
          <v-row v-if="!modalCustomSize.denuncia.novaEmpresa">
            <v-col cols="12">
              <v-autocomplete
                v-model="empresaSelecionada"
                :items="listaEmpresas"
                clearable
                label="Selecione a Empresa"
                :rules="[rules.requerido]"
                autocomplete="off"
              ></v-autocomplete>
            </v-col>

            <v-expand-transition>
              <v-col cols="12" v-if="modalCustomSize.denuncia.numeroEmpresa">
                <v-autocomplete
                  v-model="modalCustomSize.denuncia.numeroEndereco"
                  :items="listaEnderecos"
                  clearable
                  label="Selecione o Endereço"
                  :rules="[rules.requerido]"
                  autocomplete="off"
                ></v-autocomplete>
              </v-col>
            </v-expand-transition>
          </v-row>
        </v-expand-transition>

        <!-- NOVA EMPRESA -->
        <v-expand-transition>
          <v-row v-if="modalCustomSize.denuncia.novaEmpresa"> 
            <v-col cols="12">
              <v-subheader>Nova Empresa</v-subheader>
              <v-divider />
            </v-col>

            <v-col cols="6">
              <v-text-field
                v-model="modalCustomSize.denuncia.nomeFantasiaEmpresa"
                name="nomeFantasiaEmpresa"
                label="Nome do Fantasia"
                autocomplete="off"
              ></v-text-field>
            </v-col>

            <v-col cols="6">
              <v-text-field
                v-model="modalCustomSize.denuncia.razaoSocialEmpresa"
                name="razaoSocialEmpresa"
                label="Razão Social"
                autocomplete="off"
              ></v-text-field>
            </v-col>

            <v-col cols="12">
              <v-text-field
                v-model="modalCustomSize.denuncia.cnpjEmpresa"
                name="cnpjEmpresa"
                v-mask="['##.###.###/####-##']"
                label="CNPJ"
                autocomplete="off"
              ></v-text-field>
            </v-col>

            <v-col cols="12">
              <v-subheader>Novo Endereço</v-subheader>
              <v-divider />
            </v-col>

            <v-col cols="6">
              <v-text-field
                v-model="modalCustomSize.denuncia.ruaEndereco"
                name="ruaEndereco"
                label="Rua"
                autocomplete="off"
              ></v-text-field>
            </v-col>

            <v-col cols="6">
              <v-text-field
                v-model="modalCustomSize.denuncia.numEndereco"
                name="numEndereco"
                label="Numero"
                autocomplete="off"
              ></v-text-field>
            </v-col>

            <v-col cols="6">
              <v-text-field
                v-model="modalCustomSize.denuncia.bairroEndereco"
                name="bairroEndereco"
                label="Bairro"
                autocomplete="off"
              ></v-text-field>
            </v-col>

            <v-col cols="6">
              <v-text-field
                v-model="modalCustomSize.denuncia.cevsEndereco"
                name="cevsEndereco"
                label="CEVS"
                autocomplete="off"
              ></v-text-field>
            </v-col>

          </v-row>
        </v-expand-transition>

        <v-row>
          <v-col cols="12">
            <v-divider />
          </v-col>
          <v-col cols="12">
            <v-checkbox
              label="Nova Denúncia personalizada" 
              v-model="novaDenunciaPersonalizada"
              :value="true"
            ></v-checkbox>
          </v-col>
        </v-row>

        <!-- ROTEIRO EXISTENTE -->
        <v-expand-transition>
          <v-row v-if="!modalCustomSize.denuncia.denunciaPersonalizada">
            <v-col cols="12">
              <v-autocomplete
                v-model="modalCustomSize.denuncia.numeroRoteiro"
                :items="listaRoteiros"
                clearable
                label="Selecione o Roteiro"
                :rules="[rules.requerido]"
                autocomplete="off"
              ></v-autocomplete>
            </v-col>
          </v-row>
        </v-expand-transition>

        <!-- DENUNCIA PERSONALIZADA -->
        <v-expand-transition>
          <v-row v-if="modalCustomSize.denuncia.denunciaPersonalizada"> 
            <v-col cols="12">
              <v-text-field
                v-model="modalCustomSize.denuncia.nomeRoteiro"
                name="tituloRoteiro"
                label="Título do Roteiro"
                :rules="[rules.requerido]"
                autocomplete="off"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              align="center"
              v-for="(setor, i) in modalCustomSize.denuncia.setores"
              :key="i"
            >
              <v-row>
                <br />
                <v-col cols="12"><v-divider /></v-col>
                <br />

                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="mt-7"
                      icon
                      color="red"
                      v-bind="attrs"
                      v-on="on"
                      @click="removerSetor(i)"
                    >
                      <v-icon>mdi-close-circle</v-icon>
                    </v-btn>
                  </template>
                  <span>Remover Setor {{ i + 1 }}</span>
                </v-tooltip>

                <v-col>
                  <v-text-field
                    v-model="setor.nomeSetor"
                    name="nomeSetor"
                    label="Setor"
                    :rules="[rules.requerido]"
                    autocomplete="off"
                  ></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-row cols="12" v-for="(questao, j) in setor.questoes" :key="j">
                    <v-col cols="12">
                      <v-subheader> Questão {{ j + 1 }} </v-subheader>
                      <v-divider />
                    </v-col>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          class="mt-8"
                          icon
                          color="red"
                          v-bind="attrs"
                          v-on="on"
                          @click="removerQuestao(i, j)"
                        >
                          <v-icon>mdi-close-circle</v-icon>
                        </v-btn>
                      </template>
                      <span>Remover Questão {{ j + 1 }}</span>
                    </v-tooltip>

                    <v-col>
                      <v-textarea
                        v-model="questao.nomeQuestao"
                        name="nomeQuestao"
                        label="Questão"
                        rows="4"
                        row-height="30"
                        :rules="[rules.requerido]"
                        autocomplete="off"
                      ></v-textarea>
                      <v-text-field
                        v-model="questao.descricaoQuestao"
                        name="descricaoQuestao"
                        label="Lei"
                        autocomplete="off"
                      ></v-text-field>
                    </v-col>

                    <v-col v-if="questao.alternativas.length > 0" cols="5">
                      <v-row
                        cols="12"
                        align="center"
                        v-for="(alternativa, k) in questao.alternativas"
                        :key="k"
                      >
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              icon
                              color="red"
                              v-bind="attrs"
                              v-on="on"
                              @click="removerAlternativa(i, j, k)"
                            >
                              <v-icon>mdi-close-circle</v-icon>
                            </v-btn>
                          </template>
                          <span>Remover Alternativa {{ k + 1 }}</span>
                        </v-tooltip>

                        <v-col>
                          <v-text-field
                            v-model="alternativa.nomeAlternativa"
                            name="nomeAlternativa"
                            label="Alternativa"
                            :rules="[rules.requerido]"
                            autocomplete="off"
                          ></v-text-field>
                        </v-col>

                        <v-col cols="4">
                          <v-autocomplete
                            label="Tipo Alternativa"
                            :items="listaDeTipoDeAlternativa"
                            v-model="alternativa.tipoAlternativa"
                            :rules="[rules.requerido]"
                            autocomplete="off"
                          />
                        </v-col>
                      </v-row>
                    </v-col>

                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          class="mt-10"
                          icon
                          color="green"
                          v-bind="attrs"
                          v-on="on"
                          @click="novaAlternativa(i, j)"
                        >
                          <v-icon>mdi-plus-circle</v-icon>
                        </v-btn>
                      </template>
                      <span>Adicionar nova Alternativa</span>
                    </v-tooltip>
                  </v-row>
                </v-col>

                <v-col cols="12" class="ma-2">
                  <v-row>
                    <div class="pa-2">
                      <v-btn @click="novoSetor()">Novo Setor</v-btn>
                    </div>

                    <div class="pa-2">
                      <v-btn @click="novaQuestao(i)">Nova Questão</v-btn>
                    </div>

                    <div class="pa-2">
                      <v-btn @click="novaQuestaoPadrão(i)">Nova Questão Padrão</v-btn>
                    </div>
                  </v-row>
                </v-col>
                <br />
              </v-row>
            </v-col>
          </v-row>
        </v-expand-transition>

      </v-form>
    </ModalCustomSize>
    
  </v-col>
</template>

<script>
import store from "@/store/index";
import axios from "../plugins/axios";
import DataTable from "@/components/DataTable2.vue";
import SkeletonTable from "../components/SkeletonTable";
import ModalCustomSize from "../components/ModalCustomSize";
import Alertas from "../components/Alertas.vue";
import AlertasModal from "../components/AlertasModal.vue";

export default {
  components: {
    DataTable,
    SkeletonTable,
    ModalCustomSize,
    Alertas,
    AlertasModal
  },

  sockets: {
    reciveInsert: function (data) {
      if(data.tarefa.tipoTarefa == 1  && data.descricaoTela == "sincronizarTarefa") {
        this.alertaSocket.texto = 'Denúncia do numero: ' + data.tarefa.numeroTarefa + ' foi respondida.'
        this.alertaSocket.tipo = 'info'
        this.inicializar();
      }
    },
  },

  data: () => ({
    //Paginação 
    page: 1,
    search: null,
    total: null,
    //Fim da paginação

    rules: {
      requerido: (value) => value != null || "Requer o campo!",
    },

    alerta: {
      texto: "",
      tipo: ""
    },

    alertaSocket: {
      texto: "",
      tipo: "",
    },

    alertaModal: {
      texto: "",
      tipo: "",
    },

    config: {
      headers: {
        "Content-Type": "application/json",
        "x-auth-token": store.state.token,
      },
    },

    showSkeletonTable: true,
    estaValido: false,
    novaDenunciaPersonalizada: false,

    date: null,
    dateFormatted: null,
    menu: false,

    modalCustomSize: {
      size: "1600",
      isOpen: false,
      buttonText: "",
      formTitle: "",
      isEdit: false,
      isView: false,
      isLoadingRequestDisable: false,
      isButtonsVisible: false,
      isButtonsDisabled: false,
      denuncia: {
        descricaoTela: 'denuncia',
        numeroDenuncia: null,
        numeroUsuario: null,
        dataPrazo: null,

        novaEmpresa: false,
        numeroEmpresa: null,
        nomeFantasiaEmpresa: null,
        razaoSocialEmpresa: null,
        cnpjEmpresa: null,

        numeroEndereco: null,
        ruaEndereco: null,
        bairroEndereco: null,
        numEndereco: null,
        cevsEndereco: null,

        denunciaPersonalizada: false,

        numeroRoteiro: null,

        nomeRoteiro: null,
        descricaoRoteiro: null,
        cnaes: [{value: 3}],
        setores: [],
        setoresRemovidos: [],
        questoesRemovidas: [],
        alternativasRemovidas: []

      },
    },

    headers: [
      {
        text: "ID",
        value: "tarefa.numeroTarefa",
      },
      {
        text: "Usuario",
        value: "usuario.nomeUsuario",
      },
      {
        text: "Roteiro",
        value: "roteiro.nomeRoteiro",
      },
      {
        text: "Data Criação",
        value: "tarefa.dataCriacaoTarefa",
      },
      {
        text: "Data Conclusão",
        value: "tarefa.dataConclusaoTarefa",
      },
      {
        text: "Status",
        value: "tarefa.statusTarefa",
      },
      {
        text: "Tipo",
        value: "tarefa.tipoTarefa",
      },
      {
        text: "Empresa",
        value: "empresa.nomeFantasia",
      },
      { text: "Atualizar/Excluir", value: "actions", sortable: false },
    ],

    listaDeTipoDeAlternativa: [
      {
        text: "RADIO",
        value: 0,
      },
      {
        text: "CHECKBOX",
        value: 1,
      },
      {
        text: "TEXTBOX",
        value: 2,
      },
    ],

    empresaSelecionada: null,

    listaDeDenuncias: [],
    listaUsuarios: [],
    listaEmpresas: [],
    listaEnderecos: [],
    listaRoteiros: []

  }),

  created() {
    this.inicializar();
  },

  computed: {
    computedDateFormatted() {
      return this.formatDate(this.date);
    },
  },

  watch: {
    empresaSelecionada() {
      if(this.empresaSelecionada) {
        this.modalCustomSize.denuncia.numeroEmpresa = this.empresaSelecionada
        this.listarEnderecos(this.empresaSelecionada)
      } else {
        this.modalCustomSize.denuncia.numeroEmpresa = null
        this.listaEnderecos = []
      }
    },
    novaDenunciaPersonalizada() {
      this.modalCustomSize.denuncia.denunciaPersonalizada = this.novaDenunciaPersonalizada
      if(this.novaDenunciaPersonalizada) {
        this.novoSetor()
      } else {
        this.modalCustomSize.denuncia.setores = []
        this.modalCustomSize.denuncia.setoresRemovidos = []
        this.modalCustomSize.denuncia.questoesRemovidas = []
        this.modalCustomSize.denuncia.alternativasRemovidas = []
      }
    },
    estaValido() {
      this.modalCustomSize.isButtonsDisabled = !this.estaValido
    },
    date() {
      this.dateFormatted = this.formatDate(this.date);
      this.modalCustomSize.denuncia.dataPrazo = this.date
    },
  },

  methods: {
    async inicializar() {
      this.showSkeletonTable = true;
      try {
        this.listarTodasDenuncias()
        this.listarUsuarios()
        this.listarEmpresas()
        this.listarRoteiros()
      } catch (error) {
        console.log(error.response)
      }
    },

    //#region REQUEST OF LISTS
    async listarTodasDenuncias() {
      try {
        const response = await axios.put('listardenuncias', {page: this.page, search: this.search}, this.config)
        
        if(!response.data || response.data.length > 0) {
          this.listaDeDenuncias = response.data
          this.total = response.data[0].total
        }
        
      } catch (error) {
        console.log(error)
        this.alerta.texto = error.response.data.message
        this.alerta.tipo = 'erro';
      }
    },

    async updateSearch(search) {
      if(search){
        this.search = search
        this.page = 1
        await this.listarTodasDenuncias()
      } else {
        this.page = 1
      }
    },

    async updatePage(pagination) {
      this.page = pagination.page
      await this.listarTodasDenuncias()
    },

    async listarUsuarios() {
      try {
        const response = await axios.put('usuariosNivel', {numeroNivel: 22}, this.config)
        this.listaUsuarios = response.data.map((usuarioSelecionado) => {
          return {
            value: usuarioSelecionado.numeroUsuario,
            text: usuarioSelecionado.nomeUsuario
          }
        })
      } catch (error) {
        console.log(error)
      }
    },

    async listarEmpresas() {
      try {
        const response = await axios.get('empresa', this.config)
        this.listaEmpresas = response.data.map((empresaSelecionada) => {
          return {
            value: empresaSelecionada.numeroEmpresa,
            text: empresaSelecionada.nomeFantasia
          }
        })
      } catch (error) {
        console.log(error)
      }
    },

    async listarRoteiros() {
      try {
        const response = await axios.get('roteiro', this.config)
        this.listaRoteiros = response.data.map((roteiroSelecionado) => {
          return {
            value: roteiroSelecionado.numeroRoteiro,
            text: roteiroSelecionado.nomeRoteiro
          }
        })
      } catch (error) {
        console.log(error)
      } finally {
        this.showSkeletonTable = false
      }
    },

    async listarEnderecos(numeroEmpresa) {
      try {
        const response = await axios.put('endereco', {numeroEmpresa: numeroEmpresa}, this.config)
        this.listaEnderecos = response.data.map((enderecoSelecionado) => {
          if(enderecoSelecionado.cevs) {
            return {
              value: enderecoSelecionado.numeroEndereco,
              text: enderecoSelecionado.endereco + ` - ` + enderecoSelecionado.cevs
            }
          } else {
            return {
              value: enderecoSelecionado.numeroEndereco,
              text: enderecoSelecionado.endereco + ` - Não Informado`
            }
          }
        })
      } catch (error) {
        console.log(error)
      }
    },
    //#endregion

    //#region ACTIONS OF INSERT, UPDATE AND DELETE
    acaoModal() {
      try {
        if(this.modalCustomSize.isEdit) {
          this.atualizar(this.modalCustomSize.denuncia)
        } else {
          this.inserir(this.modalCustomSize.denuncia)
        }
      } catch (error) {
        console.log(error.response)
      }
    },

    async inserir(denunciaSelecionado) {
      try {
        this.alertaModal.tipo = null;
        await axios.post('denuncia', denunciaSelecionado, this.config)
        this.$socket.emit("insertApp", denunciaSelecionado);
        this.$socket.emit("insertLog");

        this.alerta.texto = "Denúncia adicionada com sucesso!"
        this.alerta.tipo = 'sucesso'

        this.modalCustomSize.isOpen = false
        this.inicializar()
      } catch (error) {
        this.alertaModal.texto = error.response.data.message
        this.alertaModal.tipo = 'erro';
        this.modalCustomSize.isOpen = true
      }
    },

    async atualizar(denunciaSelecionado) {
      try {
        this.alertaModal.tipo = null;
        await axios.put('denuncia', denunciaSelecionado, this.config)
        this.$socket.emit("insertLog");

        this.alerta.texto = "Denúncia atualizada com sucesso!"
        this.alerta.tipo = 'sucesso'

        this.modalCustomSize.isOpen = false
        this.inicializar()
      } catch (error) {
        this.alertaModal.texto = error.response.data.message
        this.alertaModal.tipo = 'erro';
        this.modalCustomSize.isOpen = true
      }
    },

    async deletarDenuncia(denunciaSelecionado) {
      try {
        if(confirm("Você realmente deseja excluir esta Denúncia?")){
          this.erro = false;
          await axios.delete("tarefas", {
            data: denunciaSelecionado.tarefa,
            headers: this.config.headers,
          });
          this.$socket.emit("insertLog");
        }

        this.alerta.texto = "Denúncia removida"
        this.alerta.tipo = 'sucesso'
      } catch (error) {
        this.alerta.texto = error.response.data.message
        this.alerta.tipo = 'erro';
      } finally {
        this.inicializar()
      }
    },
    //#endregion

    //#region MODAL POPULATE
    async inserirDenuncia() {
      this.alertaModal.texto = null
      this.alertaModal.tipo = null;

      this.modalCustomSize.isOpen = true;
      this.modalCustomSize.isEdit = false;
      this.modalCustomSize.isView = false;
      this.modalCustomSize.isButtonsVisible = true;
      this.modalCustomSize.isButtonsDisabled = !this.estaValido
      this.modalCustomSize.buttonText = "Enviar";
      this.modalCustomSize.formTitle = "Enviar Denúncia";

      this.modalCustomSize.denuncia.numeroDenuncia = null

      this.empresaSelecionada = null
      this.modalCustomSize.denuncia.novaEmpresa = false
      this.modalCustomSize.denuncia.numeroUsuario = null
      this.modalCustomSize.denuncia.dataPrazo = null
      this.modalCustomSize.denuncia.numeroEmpresa = null
      this.modalCustomSize.denuncia.nomeFantasiaEmpresa = null
      this.modalCustomSize.denuncia.razaoSocialEmpresa = null
      this.modalCustomSize.denuncia.cnpjEmpresa = null

      this.modalCustomSize.denuncia.numeroEndereco = null
      this.modalCustomSize.denuncia.ruaEndereco = null
      this.modalCustomSize.denuncia.bairroEndereco = null
      this.modalCustomSize.denuncia.numEndereco = null
      this.modalCustomSize.denuncia.cevsEndereco = null

      this.novaDenunciaPersonalizada = false
      this.modalCustomSize.denuncia.denunciaPersonalizada = false
      this.modalCustomSize.denuncia.numeroRoteiro = null
      this.modalCustomSize.denuncia.nomeRoteiro = null
      this.modalCustomSize.denuncia.setores = []
      this.modalCustomSize.denuncia.setoresRemovidos = []
      this.modalCustomSize.denuncia.questoesRemovidas = []
      this.modalCustomSize.denuncia.alternativasRemovidas = []
      this.date = null;

    },

    async editarDenuncia(denunciaSelecionado) {
      this.alertaModal.texto = null
      this.alertaModal.tipo = null;
      
      this.modalCustomSize.isOpen = true;
      this.modalCustomSize.isEdit = true;
      this.modalCustomSize.isView = false;
      this.modalCustomSize.isButtonsVisible = true;
      this.modalCustomSize.isButtonsDisabled = !this.estaValido
      this.modalCustomSize.buttonText = "Atualizar";
      this.modalCustomSize.formTitle = "Atualizar Denúncia";

      this.modalCustomSize.denuncia.numeroDenuncia = denunciaSelecionado.tarefa.numeroTarefa
      this.modalCustomSize.denuncia.numeroUsuario = denunciaSelecionado.usuario.numeroUsuario
      this.modalCustomSize.denuncia.dataPrazo = denunciaSelecionado.tarefa.dataTarefa
      this.modalCustomSize.denuncia.numeroEmpresa = denunciaSelecionado.empresa.numeroEmpresa
      this.empresaSelecionada = denunciaSelecionado.empresa.numeroEmpresa
      this.modalCustomSize.denuncia.numeroEndereco = denunciaSelecionado.endereco.numeroEndereco
      this.modalCustomSize.denuncia.numeroRoteiro = denunciaSelecionado.roteiro.numeroRoteiro

      this.modalCustomSize.denuncia.novaEmpresa = false
      this.modalCustomSize.denuncia.nomeFantasiaEmpresa = null
      this.modalCustomSize.denuncia.razaoSocialEmpresa = null
      this.modalCustomSize.denuncia.cnpjEmpresa = null

      this.modalCustomSize.denuncia.ruaEndereco = null
      this.modalCustomSize.denuncia.bairroEndereco = null
      this.modalCustomSize.denuncia.numEndereco = null
      this.modalCustomSize.denuncia.cevsEndereco = null

      this.novaDenunciaPersonalizada = false
      this.modalCustomSize.denuncia.denunciaPersonalizada = false
      this.modalCustomSize.denuncia.nomeRoteiro = null
      this.modalCustomSize.denuncia.setores = []
      this.modalCustomSize.denuncia.setoresRemovidos = []
      this.modalCustomSize.denuncia.questoesRemovidas = []
      this.modalCustomSize.denuncia.alternativasRemovidas = []
      this.date = this._formatStringInBrazilianDateFormat(this.modalCustomSize.denuncia.dataPrazo);
    },
    //#endregion

    //#region ACTIONS OF ROTEIRO
    novoSetor() {
      this.modalCustomSize.denuncia.setores.push({
        numeroSetor: null,
        nomeSetor: null,
        questoes: [],
      });
    },

    novaQuestao(indiceSetor) {
      this.modalCustomSize.denuncia.setores[indiceSetor].questoes.push({
        numeroQuestao: null,
        nomeQuestao: null,
        descricaoQuestao: null,
        alternativas: [],
      });
    },

    novaQuestaoPadrão(indiceSetor) {
      this.modalCustomSize.denuncia.setores[indiceSetor].questoes.push({
        numeroQuestao: null,
        nomeQuestao: null,
        descricaoQuestao: null,
        alternativas: [
          {
            numeroAlternativa: null,
            nomeAlternativa: "SIM",
            tipoAlternativa: 0,
          },
          {
            numeroAlternativa: null,
            nomeAlternativa: "NÃO",
            tipoAlternativa: 0,
          },
          {
            numeroAlternativa: null,
            nomeAlternativa: "NA",
            tipoAlternativa: 0,
          },
          {
            numeroAlternativa: null,
            nomeAlternativa: "NO",
            tipoAlternativa: 0,
          },
        ],
      });
    },

    novaAlternativa(indiceSetor, indiceQuestao) {
      this.modalCustomSize.denuncia.setores[indiceSetor].questoes[indiceQuestao].alternativas.push({
        numeroAlternativa: null,
        nomeAlternativa: null,
        tipoAlternativa: null,
      });
    },

    removerSetor(indiceSetor) {
      if(confirm("Você realmente deseja remover esse Setor? (A exclusão desse Setor acarretara à exclusão de respostas desse Setor)")) {
        this.modalCustomSize.denuncia.setoresRemovidos.push(this.modalCustomSize.denuncia.setores.splice(indiceSetor, 1))
      }
    },

    removerQuestao(indiceSetor, indiceQuestao) {
      if(confirm("Você realmente deseja remover essa Questão? (A exclusão dessa Questão poderá acarretar à exclusão de respostas relacionada a ela)")) {
        this.modalCustomSize.denuncia.questoesRemovidas.push(this.modalCustomSize.denuncia.setores[indiceSetor].questoes.splice(indiceQuestao, 1))
      }
    },

    removerAlternativa(indiceSetor, indiceQuestao, indiceAlternativa) {
      if(confirm("Você realmente deseja remover essa Alternativa? (A exclusão dessa Alternativa poderá acarretar à exclusão de respostas referentes a essa Alternativa)")) {
        this.modalCustomSize.denuncia.alternativasRemovidas.push(this.modalCustomSize.denuncia.setores[indiceSetor].questoes[indiceQuestao].alternativas.splice(indiceAlternativa, 1))
      }
    },
    //#endregion

    //#region FORMAT DATE
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    
    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },

    _formatStringInBrazilianDateFormat(data) {
      if(data){
        var ano = data.split("-")[0];
        var mes = data.split("-")[1];
        var dia = data.split("-")[2];
        var dia2 = dia.substring(0, 2);
        return ano + "-" + ("0" + mes).slice(-2) + "-" + ("0" + dia2).slice(-2);
        // Utilizo o .slice(-2) para garantir o formato com 2 digitos.
      } else {
        return 'Sem Data'
      }
    },
    //#endregion
    
  },
};
</script>
